// extracted by mini-css-extract-plugin
export default {"ResumeStatus":"resume-status_ResumeStatus__xtLZD","ResumeStatusItemWrapper":"resume-status_ResumeStatusItemWrapper__aJlD8","label":"resume-status_label__EmhB-"};